'use client';
import { useEffect, useState } from 'react';

/**
 * 없는 주소.
 *
 * **어드민에서는 옮기지 않는다.** 예전에는 무조건 `/` 로 replace 했는데, 어드민의 잘못된
 * 링크·지워진 문서가 전부 콘솔 홈으로 흘러가서 "없는 주소였다"는 사실 자체가 안 보였다.
 * 어디가 끊겼는지 알아야 고칠 수 있으므로 주소를 그대로 두고 말한다.
 */
const NotFound = () => {
	const [adminPath, setAdminPath] = useState<string | null>(null);

	useEffect(() => {
		const path = window.location.pathname;
		if (path === '/admin' || path.startsWith('/admin/')) {
			setAdminPath(path);
			return;
		}
		window.location.replace('/');
	}, []);

	if (!adminPath) return null;

	return (
		<div style={{ maxWidth: 520, margin: '18vh auto', padding: '0 24px', fontFamily: 'system-ui, sans-serif' }}>
			<h2 style={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.01em', color: '#171717' }}>없는 주소예요</h2>
			<p style={{ marginTop: 8, fontSize: 14, lineHeight: 1.7, color: '#525252' }}>
				주소가 바뀌었거나 지워진 항목일 수 있어요.
			</p>
			<p style={{ marginTop: 12, fontFamily: 'ui-monospace, monospace', fontSize: 12, color: '#a3a3a3' }}>{adminPath}</p>
			<a
				href="/admin"
				style={{
					marginTop: 20,
					height: 38,
					padding: '0 16px',
					display: 'inline-flex',
					alignItems: 'center',
					borderRadius: 999,
					background: '#171717',
					color: '#fff',
					fontSize: 13,
					fontWeight: 700,
					textDecoration: 'none',
				}}
			>
				대시보드로
			</a>
		</div>
	);
};

export default NotFound;
